import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, map, Observable, Subject } from 'rxjs';
import { EwayBillDetailsInven, EWayDataModel } from 'src/app/core/models/masters/eway.model';
import { GlobalProperties } from 'src/app/global/global-properties';
import { WrapperStandardRequest } from 'src/app/infrastructure/infrastructure-services/common/models/wrapper.model';
import { GenericService } from 'src/app/infrastructure/infrastructure-services/services/base/generic-service';

@Injectable({
  providedIn: 'root'
})
export class EWayService {
  move$: Observable<any>;
  private moveSubject: Subject<any> = new Subject();
  public callEnvoice: BehaviorSubject<any> = new BehaviorSubject<any>(false);

  constructor(private genericService: GenericService<any>, private http: HttpClient,private datePipe: DatePipe) { 
   this.move$ = this.moveSubject.asObservable();
  }
  
   getSubType(body: WrapperStandardRequest<any>) {
      return this.genericService.PostAPI(GlobalProperties.getApiUrl + 'Statutory/GetSubTypeService', body).pipe(map(res => res as any));
   }

   getTransportationMode(body: WrapperStandardRequest<any>) {
      return this.genericService.PostAPI(GlobalProperties.getApiUrl + 'Statutory/GetTransportationModeService', body).pipe(map(res => res as any));
   }

   getTransporters(body: WrapperStandardRequest<any>) {
      return this.genericService.PostAPI(GlobalProperties.getApiUrl + 'EWBTransporters/GetEWBTransportersDetails', body).pipe(map(res => res as any));
   }

   getCancellationRemarks(body: WrapperStandardRequest<any>) {
      return this.genericService.PostAPI(GlobalProperties.getApiUrl + 'EWBTransporters/GetCancellationRemarks', body).pipe(map(res => res as any));
   }

   getVehicleType(body: WrapperStandardRequest<any>) {
      return this.genericService.PostAPI(GlobalProperties.getApiUrl + 'Statutory/GetVehicleTypeService', body).pipe(map(res => res as any));
   }

   getHSNType(body: WrapperStandardRequest<any>) {
      return this.genericService.PostAPI(GlobalProperties.getApiUrl + 'Statutory/GetHSNMaster', body).pipe(map(res => res as any));
   }

   getStateList(body: WrapperStandardRequest<any>) {
      return this.genericService.PostAPI(GlobalProperties.getApiUrl + 'State/GetStateListService', body).pipe(map(res => res as any));
   }

   getDocumentType(body: WrapperStandardRequest<any>) {
      return this.genericService.PostAPI(GlobalProperties.getApiUrl + 'Statutory/GetDocumentTypeService', body).pipe(map(res => res as any));
   }

   getValues(list: Array<any>, value: any, propertyValue: string, propertyName: string) {
    if (value && list.length != 0) {
      return value = list?.filter(el => el[propertyValue] == value)[0][propertyName];
    }
    return value
  }

  postEinvoiceData(body: WrapperStandardRequest<any>) {
    return this.genericService.PostAPI('https://erp.connectrix.in/UneecopsSuitAPIV1/api/V2/ForProcessEInvoiceRequest', body).pipe(map(res => res as any));
  }

  postEWayData(body: WrapperStandardRequest<any>) {
    return this.genericService.PostAPI(GlobalProperties.getApiUrl + 'V2/ForConnectrixWebToProcessEWayBillRequest', body).pipe(map(res => res as any));
  }

  public indicateIRNSuccess(val: any) {
    this.moveSubject.next(val);
  }

  getFormatDate(date: any) {
    if (date) {
      date = this.datePipe.transform(date, 'yyyy-MM-dd')
    }
    return date
  }

  saveEwayInTrans(body: EwayBillDetailsInven, methodTypePatch: boolean, docEntry: number): Observable<any> {
    switch (methodTypePatch) {
      case true:
        return this.genericService.PostAPI(GlobalProperties._apiUrlSap + `UTL_ST_UDO_TREWAYDT(${docEntry})`, body).pipe(map(res => res as any));
      case false:
        return this.genericService.PostAPI(GlobalProperties._apiUrlSap + 'UTL_ST_UDO_TREWAYDT', body).pipe(map(res => res as any));
    }
  }

  getBillToData(body: WrapperStandardRequest<any>) {
    return this.genericService.PostAPI(GlobalProperties.getApiUrl + 'Statutory/GetBillToDetailsByCardCodeService', body).pipe(map(res => res as any));
  }

  getBillFromData(body: WrapperStandardRequest<any>) {
    return this.genericService.PostAPI(GlobalProperties.getApiUrl + 'Statutory/GetBillFromDetailsByWarehouseCode', body).pipe(map(res => res as any));
  }

  getSalesInvoice(docEntry: number) {
    return this.genericService.GetAPI(GlobalProperties._apiUrlSap + `Invoices(${docEntry})`);
  }

  getInventoryEway(docEntry: number, objectType: number): Observable<any> {
    return this.genericService.GetAPI(GlobalProperties._apiUrlSap + `UTL_ST_UDO_TREWAYDT?$filter=U_UTL_ST_DocEnt eq '${docEntry}' and U_UTL_ST_BSobjTyp eq '${objectType}'`).pipe(map(res => res as any));
  }

  getEInvoiceData(docEntry: number, docType: string) {
    return this.genericService.GetAPI(GlobalProperties._apiUrlSap + `UTL_MDEXT_UOM?$filter=U_UTL_BaseEntry eq '${docEntry}' and U_UTL_DocType eq '${docType}'`);
  }

  _getEWayData(docEntry: number, docType: string) {
    return this.genericService.GetAPI(GlobalProperties._apiUrlSap + `UTL_ST_UDO_EWB?$filter=U_UTL_ST_BaseEntry eq '${docEntry}' and U_UTL_ST_DocType eq '${docType}'`);
  }
   
}
